import { render, staticRenderFns } from "./CardDeLoja.vue?vue&type=template&id=340ea4b8&scoped=true&"
import script from "./CardDeLoja.vue?vue&type=script&lang=ts&"
export * from "./CardDeLoja.vue?vue&type=script&lang=ts&"
import style0 from "./CardDeLoja.vue?vue&type=style&index=0&id=340ea4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340ea4b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VIcon,VImg})
